/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Pazaryeri_BaglantisiInputs */

const tr_faq_q_pazaryeri_baglantisi = /** @type {(inputs: Faq_Q_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk pazaryeri bağlantısı nasıl yapılır?`)
};

const en_faq_q_pazaryeri_baglantisi = /** @type {(inputs: Faq_Q_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I connect my first marketplace?`)
};

const de_faq_q_pazaryeri_baglantisi = /** @type {(inputs: Faq_Q_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie verbinde ich meine erste Verkaufsplattform?`)
};

const ru_faq_q_pazaryeri_baglantisi = /** @type {(inputs: Faq_Q_Pazaryeri_BaglantisiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как подключить первую площадку?`)
};

/**
* | output |
* | --- |
* | "How do I connect my first marketplace?" |
*
* @param {Faq_Q_Pazaryeri_BaglantisiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_pazaryeri_baglantisi = /** @type {((inputs?: Faq_Q_Pazaryeri_BaglantisiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Pazaryeri_BaglantisiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_pazaryeri_baglantisi(inputs)
	if (locale === "de") return de_faq_q_pazaryeri_baglantisi(inputs)
	if (locale === "ru") return ru_faq_q_pazaryeri_baglantisi(inputs)
	return tr_faq_q_pazaryeri_baglantisi(inputs)
});